import React from 'react'
import { createRoot } from 'react-dom/client'
import './i18n'

import App from './App'

createRoot(document.getElementById('root')).render(<App />)

// import registerServiceWorker from './registerServiceWorker'
// registerServiceWorker()
